import { CollapsibleContext } from "./chunk-P4FH6SY6.js";
import { TransitionComponent } from "./chunk-QUQRJRHE.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Collapsible/Collapsible.Panel.tsx
import { Fragment, useContext } from "react";
import clsx from "clsx";
import { DisclosurePanel } from "@headlessui/react";
import { jsx } from "react/jsx-runtime";
var CollapsiblePanel = _a => {
  var _b = _a,
    {
      children,
      unmount,
      className
    } = _b,
    rest = __objRest(_b, ["children", "unmount", "className"]);
  const {
    isOpen
  } = useContext(CollapsibleContext);
  return /* @__PURE__ */jsx(TransitionComponent, {
    as: Fragment,
    variant: "appear-from-top",
    unmount,
    show: isOpen,
    children: /* @__PURE__ */jsx(DisclosurePanel, __spreadProps(__spreadValues({}, rest), {
      static: true,
      className: clsx("pd:collapsible__panel", className),
      children
    }))
  });
};
var Collapsible_Panel_default = CollapsiblePanel;
export { Collapsible_Panel_default };